import logo2 from 'assets/images/art-friendly/logo2.svg';

const Logo = () => {
  return <img src={logo2} className="absolute h-14 left-4" />;
};

export default Logo;
